import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { SharedService } from 'app/shared/services/shared.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { UserService } from 'app/shared/services/user.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { CampaignsService } from 'app/shared/services/campaigns.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'cedato-manage-campaigns',
  templateUrl: './manage-campaigns.component.html',
  styleUrls: ['./manage-campaigns.component.scss'],
})
export class ManageCampaignsComponent implements OnInit {
  public data: any;
  public columnsSettings: Array<any>;
  public gridCustomSettings: Array<any>;
  public isLoading: boolean;
  public isError: boolean;
  public emptyDataSettings: any;
  public activeEntities: boolean;
  public gridFilters: any;
  public getBudgetsObservable: any;
  public subscriptions: Array<any>;

  constructor(
    public httpService: HttpService,
    public gridService: GridService,
    public sharedService: SharedService,
    public modalsService: ModalsService,
    public userService: UserService,
    public ga: GoogleAnalyticsService,
    public router: Router,
    public campaignsService: CampaignsService,
    public dictionaryService: DictionaryService
  ) {
    this.columnsSettings = [
      {
        key: '$$active',
        label: 'LIVE',
        parseTooltipFunction: this.gridService.parseBooleanTooltip,
        isActiveButton: true,
      },
      { key: 'id', label: 'CAMPAIGN_ID', width: 150, filterType: 'INPUT' },
      { key: 'name', label: 'CAMPAIGN_NAME', filterType: 'INPUT' },
      {
        key: 'running',
        label: 'IS_RUNNING',
        width: 100,
        filterType: 'SELECT',
        parseFunction: this.gridService.parseRunning,
      },
      { key: 'hourly', label: 'HOURLY', width: 100, filterType: 'RANGE' },
      { key: 'daily', label: 'DAILY', width: 100, filterType: 'RANGE' },
      { key: 'type', label: 'ASSIGNED', width: 150, filterType: 'SELECT' },
      {
        key: 'start',
        label: 'START_DATE',
        width: 180,
        filterType: 'INPUT',
        parseFunction: this.gridService.parseDayTime,
        parseTooltipFunction: this.gridService.parseDayTime,
      },
      {
        key: 'end',
        label: 'END_DATE',
        width: 180,
        filterType: 'INPUT',
        parseFunction: this.gridService.parseDayTime,
        parseTooltipFunction: this.gridService.parseDayTime,
      },
    ];
    this.subscriptions = [];
    this.data = [];
    this.gridFilters = [];
  }

  ngOnInit() {
    if (this.userService.getFeatureState('manage_campaigns')) {
      this.initialize();
    } else {
      this.router.navigate(['/']);
      return;
    }

    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'GRID_VALUE_CHANGE') {
          this.onActiveClick(response.data);
        } else if (response.type === 'NETWORK_CHANGE') {
          if (!this.userService.getFeatureState('manage_campaigns')) { this.router.navigate(['/']); }
        }
      })
    );
    this.sharedService.setPageTitle('MANAGE_CAMPAIGNS');
  }

  ngOnDestroy() {}

  initialize() {
    this.getBudgetsList();
  }

  getBudgetsList() {
    if (this.getBudgetsObservable) { this.getBudgetsObservable.unsubscribe(); }

    const params: any = {};
    let currency = '';
    this.isLoading = true;

    this.getBudgetsObservable = this.httpService.post('budget_manager/get', params).subscribe(
      (response: any) => {
        const data = response.data;
        for (let i = 0; i < data.length; i++) {
          currency = this.campaignsService.getCurrencyString(+data[i].cid);
          data[i].$$id = +data[i].id;
          data[i].$$active = !!+data[i].active;
          data[i].type = this.campaignsService.getCampaignType(+data[i].type);
          data[i].running = this.campaignsService.getRunningState(data[i])
            ? this.dictionaryService.get('IS_RUNNING')
            : this.dictionaryService.get('NOT_RUNNING');
          data[i].hourly =
            +data[i].hourly === 0
              ? '–'
              : currency + this.sharedService.toLocaleString(this.campaignsService.parseFloat(data[i].hourly));
          data[i].daily =
            +data[i].daily === 0
              ? '–'
              : currency + this.sharedService.toLocaleString(this.campaignsService.parseFloat(data[i].daily));

          data[i].$$link = 'campaigns/manage/';
          data[i].$$actions = [{ type: 'EDIT', link: true, linkOverride: data[i].$$id }];
        }
        this.data = data;
        this.isLoading = false;
      },
      (error: any) => {
        this.isLoading = false;
        this.isError = true;
      }
    );
  }

  createNewCampaignBtnClick() {
    this.router.navigate(['campaigns/new'], {});
  }

  onActiveClick(data: any) {
    const id: string = data.dataItem.$$id.toString();
    const state: number = +data.dataItem.$$active === 1 ? 0 : 1;
    this.toggleCampaign(id, state);
  }

  toggleCampaign(id: string = '0', state: number = 0) {
    if (id === '0') { return false; }

    const params: any = {
      id,
      state,
    };
    this.isLoading = true;
    this.subscriptions.push(
      this.httpService.post('budget_manager/toggle', params).subscribe((response: any) => {
        this.sharedService.showFlashMessage(this.dictionaryService.get('UPDATED_SUCCESSFULLY'), 'success');
        this.getBudgetsList();
        this.isLoading = false;
      })
    );
  }
}
